<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
  <div class="container-fluid padding-bottom-small bottom-padding">
    <div class="col-sm-11 center-block">
        <div class="row">
            <div class="col-sm-8">
                <h1 tabindex="0" aria-label="New Product Labeling/Listing" role="heading" aria-level="1">New Product Labeling/Listing</h1>
                <p role="paragraph" tabindex="0">
                    The fields below are required to start a new Product Labeling/Listing form.  If you haven't already, make sure you have completed the following prerequisites to make the completion of your Product Labeling/Listing form a lot easier: a Labeler Code Request, added Companies and Contacts, and created an Establishment Registration.
                </p>
            </div>
        </div>

       <!--   -->
        <div class="row">
            <div class="top-space col-sm-12">
                <form [formGroup]="wizardForm" novalidate #createForm="ngForm" (ngSubmit)="createLLForm()" tabindex="0" role="form" aria-label="create LL form">
                    <div class="row">
                        <div class="form-group">
                            <div class="form-group col-md-6">
                                <label for="formName" id="formName-label">Form name</label>
                                <input type="text" formControlName="formName"
                                placeholder='Enter a Form Name'class="form-control required" maxlength="255" [ngClass]="{ 'is-invalid': formErrors?.formName }" (blur)="onBlur()"
                                aria-labelledby="formName-label" aria-label="Enter a Form Name" tabindex="0" role="texxtbox" aria-required="true"/>
                                <div *ngIf="formErrors?.formName" class="alert-text" [attr.aria-label]="formErrors?.formName">
                                   {{formErrors?.formName}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group">
                            <div class="form-group col-md-6">
                                <label for="productTypeId" id="productTypeId-label">Product type</label>
                                <ejs-dropdownlist id="productTypeId" [dataSource]='productTypesDataSource' [value]="selectedProductType"
                                                  [fields]='productTypeFields' [placeholder]='productTypeWaterMark' showClearButton=true
                                                  (change)='productTypeSelectionChanged($event)' class="required"
                                                  formControlName="productTypeId" name="productTypeId" [popupHeight]='ddwHeight'
                                                  [ngClass]="{required:true, 'is-invalid': formErrors?.productTypeId }">
                                </ejs-dropdownlist>
                                <div *ngIf="formErrors?.productTypeId" class="alert-text" [attr.aria-label]="formErrors?.productTypeId">
                                  {{formErrors?.productTypeId}}
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group">
                            <div class="form-group col-md-6">
                                <label for="effectiveDate" id="effectiveDate-label">Effective date</label>
                                <ejs-datepicker id='effectiveDate' #effDate (open)="onOpen($event)"
                                        placeholder='Select a date' [(value)]='dateValue' [format]="dateFormat">
                                </ejs-datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                          <label for="status" id="status-label">Does this contain a kit?</label>
                          <div class="col-md-12">
                              <div class="form-check form-check-inline">
                                <input type="radio" formControlName="isKit" value="Yes" id="yesKit" class="form-check-input"
                                tabindex="0" aria-labelledby="yesKit-label" aria-label="Does contain a kit" role="radio"/>
                                <label class="form-check-label" for="yesKit" id="yesKit-label">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input type="radio" formControlName="isKit" value="No" id="noKit" class="form-check-input" checked
                                tabindex="0" aria-labelledby="noKit-label" aria-label="Does not contain a kit" role="radio"/>
                                <label class="form-check-label" for="noKit" id="noKit-label">No</label>
                              </div>
                          </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <span>
                                <a class="btn btn-default margin-right" (click)="cancelBtnClicked()"
                                tabindex="0" role="link" aria-label="Cancel" (keydown.enter)="cancelBtnClicked()">Cancel</a>
                            </span>
                            <span>
                                <button class="btn btn-primary"
                                tabindex="0" role="button" aria-label="Next">Next</button>
                            </span>
                            <span *ngIf="errorMessage" class="alert-text left-padding alert" [attr.aria-label]="errorMessage">{{errorMessage}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div *ngIf="loading">
            <div id="loading"></div>
        </div>
    </div>

</div>
</main>
